import { render, staticRenderFns } from "./AppConsumer.vue?vue&type=template&id=fec07610&"
import script from "./AppConsumer.vue?vue&type=script&lang=js&"
export * from "./AppConsumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports